import { action } from 'typesafe-actions';
import { ArcgisActionTypes } from 'types';

export const getArcgisPasswordStart = () =>
  action(ArcgisActionTypes.GET_ARCGIS_PWD_START);

export const getArcgisPasswordSuccess = (payload: any) =>
  action(ArcgisActionTypes.GET_ARCGIS_PWD_SUCCESS, payload);

export const getArcgisPasswordFailure = (payload: string) =>
  action(ArcgisActionTypes.GET_ARCGIS_PWD_FAILURE, payload);

export const addArcgisPasswordStart = (replaceExisting: boolean) =>
  action(ArcgisActionTypes.ADD_ARCGIS_PWD_START, replaceExisting);

export const addArcgisPasswordSuccess = (payload: any) =>
  action(ArcgisActionTypes.ADD_ARCGIS_PWD_SUCCESS, payload);

export const addArcgisPasswordFailure = (payload: string) =>
  action(ArcgisActionTypes.ADD_ARCGIS_PWD_FAILURE, payload);

export const deleteArcgisPasswordStart = () =>
  action(ArcgisActionTypes.DELETE_ARCGIS_PWD_START);

export const deleteArcgisPasswordSuccess = () =>
  action(ArcgisActionTypes.DELETE_ARCGIS_PWD_SUCCESS);

export const deleteArcgisPasswordFailure = (payload: string) =>
  action(ArcgisActionTypes.DELETE_ARCGIS_PWD_FAILURE, payload);

export const resetArcgisPassword = () =>
  action(ArcgisActionTypes.RESET_ARCGIS_PWD);
